import React from 'react';

interface JobDetailsProps {
    jobDetails: {
        contractor?: { name: string };
        generalContractor?: { name: string };
        siteContact: string;
        siteContactEmail: string;
        jobDetailsSectors: Array<{ sector: { name: string } }>;
        industry: { name: string };
        jobCompletionStatus: { status: string };
        hasPLA?: boolean;
        hasMRF?: boolean;
    };
    getStatusCompletionPercentage: (status: string) => string;
}

const JobDetailsSection: React.FC<JobDetailsProps> = ({ jobDetails, getStatusCompletionPercentage }) => {
    return (
        <div className='bg-white rounded-md shadow mb-4'>
            <div className='p-4 sm:p-6'>
                <div>
                    <h2 className='text-[20px] font-[700] mb-3'>Job Details</h2>
                    <div className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4'>
                        <div className='mb-3'>
                            <p className='text-[16px] font-[700] text-black'>General Contractor</p>
                            <p className='text-[16px] font-[500]'>{jobDetails?.generalContractor?.name || jobDetails?.contractor?.name || '-'}</p>
                        </div>
                        <div className='mb-3'>
                            <p className='text-[16px] font-[700] text-black'>Site Contact</p>
                            <p className='text-[16px] font-[500]'>{jobDetails?.siteContact || '-'}</p>
                        </div>
                        <div className='mb-3'>
                            <p className='text-[16px] font-[700] text-black'>Site Contact Email</p>
                            <p className='text-[16px] font-[500]'>{jobDetails?.siteContactEmail || '-'}</p>
                        </div>
                        <div className='mb-3'>
                            <p className='text-[16px] font-[700] text-black'>Sector{jobDetails?.jobDetailsSectors && jobDetails.jobDetailsSectors.length > 1 ? 's' : ''}</p>
                            <p className='text-[16px] font-[500]'>
                                {jobDetails?.jobDetailsSectors?.map(jds => jds.sector?.name).filter(Boolean).join(', ') || '-'}
                            </p>
                        </div>
                        <div className='mb-3'>
                            <p className='text-[16px] font-[700] text-black'>Industry</p>
                            <p className='text-[16px] font-[500]'>{jobDetails?.industry?.name || '-'}</p>
                        </div>
                        <div className='mb-3'>
                            <p className='text-[16px] font-[700] text-black'>Job Completion</p>
                            <p className='text-[16px] font-[500]'>{getStatusCompletionPercentage(jobDetails?.jobCompletionStatus?.status) || '-'}</p>
                        </div>
                        <div className='mb-3'>
                            <p className='text-[16px] font-[700] text-black'>Project Labor Agreement (PLA)</p>
                            <p className='text-[16px] font-[500]'>{jobDetails?.hasPLA ? 'Yes' : 'No'}</p>
                        </div>
                        <div className='mb-3'>
                            <p className='text-[16px] font-[700] text-black'>Market Recovery Fund (MRF)</p>
                            <p className='text-[16px] font-[500]'>{jobDetails?.hasMRF ? 'Yes' : 'No'}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default JobDetailsSection; 